import { FC, ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import EditSvg from '~/@ui/_sharedSvgs/ui/Edit.svg?react'

export const RowLabelValueIcon: FC<{
  label: string
  value?: ReactNode
  icon?: ReactNode
  editable?: boolean
  handleEditClick?: () => void
}> = ({ label, value, icon, editable, handleEditClick }) => {
  return (
    <Stack direction="row" className="items-center md:min-w-[220px] gap-2">
      {icon}
      <Stack>
        <Typography className="text-xs font-medium text-zGrey600">
          {label}
        </Typography>
        {value && (
          <Typography className="text-base font-medium text-zBlack300">
            {value}
          </Typography>
        )}
      </Stack>
      {editable && (
        <Box onClick={handleEditClick} className="!ml-auto">
          <EditSvg />
        </Box>
      )}
    </Stack>
  )
}
